import { configureStore } from "@reduxjs/toolkit";
import termLifeSlice from "./redux/slice/termLifeSlice";

export const store = configureStore({
  reducer: {
    termLife: termLifeSlice
  },
});
